import withSideDropMenu from './with-side-dropmenu';

export default withSideDropMenu;